import React from "react"

export function CloseIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.6567 12L18.5658 7.09097L16.9091 5.43433L12 10.3434L7.09097 5.43433L5.43433 7.09097L10.3434 12L5.43433 16.9091L7.09097 18.5658L12 13.6567L16.9091 18.5658L18.5658 16.9091L13.6567 12Z"
        fill="currentColor"
      />
    </svg>
  )
}
